/**
 * Herkunft eines Schreibens aus einer (Unter-)Aufgabe (25.10.2026): Haupt-/Unteraufgabe öffnen, Beschluss (Original) ansehen,
 * Hinweise der Vorbelegung (z. B. fehlende Anschrift). Nach dem Versand bleibt die Aufgabe offen – Antwort weiter nachhalten.
 */
import { useContext } from 'react';
import { toast } from 'sonner';
import { CornerLeftUp, FileText } from 'lucide-react';
import TabContext from '@/contexts/TabContext';
import { authAPI } from '@/api/authAPI';
import { ohneKlient } from './AufgabenBezugTitel';

const API = process.env.NODE_ENV === 'production' ? '' : (process.env.REACT_APP_BACKEND_URL || '');

export default function AufgabenBezug({ kontext, versendet, klientName }) {
  const tabs = useContext(TabContext);
  if (!kontext || !kontext.unteraufgabe_id) return null;
  const oeffne = (id, titel) => (tabs?.openTab ? tabs.openTab(`/aufgaben/${id}`, ohneKlient(titel, klientName) || 'Aufgabe') : window.open(`/aufgaben/${id}`, '_blank'));
  const beschluss = async () => {
    try {
      const r = await authAPI.apiFetch(`${API}/api/betreuung/dokumente/${encodeURIComponent(kontext.beschluss_dokument_id)}/download-ticket`);
      const d = r.ok ? await r.json() : null;
      if (!d?.ticket) throw new Error('Beschluss nicht verfügbar');
      window.open(`${API}/api/betreuung/dokumente/${encodeURIComponent(kontext.beschluss_dokument_id)}/download?inline=true&ticket=${encodeURIComponent(d.ticket)}`, '_blank');
    } catch (e) { toast.error(e.message); }
  };
  const hinweise = versendet ? [] : (kontext.hinweise || []).slice(1);
  return (
    <div className="text-xs bg-blue-50 text-blue-900 rounded p-2 my-2 space-y-1" data-testid="sst-aufgabenbezug">
      <div className="flex flex-wrap items-center gap-x-1.5 gap-y-1">
        <CornerLeftUp size={13} className="shrink-0" />
        <span>Aus Aufgabe:</span>
        {kontext.hauptaufgabe_id && (
          <>
            <button type="button" className="underline hover:text-blue-700" onClick={() => oeffne(kontext.hauptaufgabe_id, kontext.hauptaufgabe_titel)}
              data-testid="sst-hauptaufgabe">{ohneKlient(kontext.hauptaufgabe_titel, klientName)}</button>
            <span>›</span>
          </>
        )}
        <button type="button" className="underline hover:text-blue-700 font-medium" onClick={() => oeffne(kontext.unteraufgabe_id, kontext.unteraufgabe_titel)}
          data-testid="sst-unteraufgabe">{ohneKlient(kontext.unteraufgabe_titel, klientName)}</button>
        {kontext.beschluss_dokument_id && (
          <button type="button" className="ml-auto inline-flex items-center gap-1 underline hover:text-blue-700" onClick={beschluss} data-testid="sst-beschluss">
            <FileText size={13} /> Beschluss ansehen
          </button>
        )}
      </div>
      {hinweise.map((h) => <div key={h} className="text-amber-800" data-testid="sst-aufgabenbezug-hinweis">{h}</div>)}
      {versendet && <div data-testid="sst-aufgabenbezug-offen">Die Aufgabe bleibt offen, bis die Antwort vorliegt – bitte dort erledigen.</div>}
    </div>
  );
}
